export const Logo = ({ dark = false, className = "" }) => (
  <img
    src="/logo.png"
    alt="RK Real Estate"
    data-testid="brand-logo"
    className={`h-[52px] sm:h-[56px] w-auto object-contain ${className}`}
  />
);
